<template>
  <div class="c-routes-list">
    <v-chip
      v-for="item in routes_by_rect"
      :key="item.route_and_type"
      class="mx-1"
      close
      close-icon="mdi-close"
      :color="colorRoute(item)"
      text-color="#000"
      outlined
      small
      @mousedown.prevent.stop
      @click:close="removeRoute(item)"
      @click.stop="rectActivate()"
      :disabled="is_loading"
    >
      {{ item.text }}, TC: {{ carsCountInRoute(item.route_and_type) }}
    </v-chip>
  </div>
</template>

<script>
import { ClassColor } from '@/helpers/base/colors'
export default {
  name: 'c-routes-list',
  props: {
    rect_id: {
      type: [Number, String],
      default: null
    },
    is_loading: {
      type: Boolean,
      default: false
    },
    cars_list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    routes_by_rect() {
      return this.$store.getters.RECT_ROUTES_BY_RECT_ID(this.rect_id)
    }
  },
  methods: {
    rectActivate() {
      this.$emit('rectActivate')
    },
    /* Хэлперы */
    colorRoute(v) {
      const color = new ClassColor()
      let filter_by_type = this.routes_by_rect.filter(i => i.route_type == v.route_type)
      return color.byRouteInMap(v, v.route_type, filter_by_type)
    },
    carsCountInRoute(route_and_type) {
      let result = this.cars_list.filter(i => i.route_and_type == route_and_type)
      return result.length
    },
    /* Хэлперы END */

    removeRoute(item) {
      this.rectActivate();
      this.$emit('removeRoute', item)
    },
  }
}
</script>

<style lang="scss">
  .c-routes-list {
    .v-chip {
      margin: 6px 0;
      .v-chip__content {
        font-size: 13px;
      }
    }
    .v-chip.v-chip--outlined {
      border-width: 2px;
    }
  }
</style>